import { SmsConsentStatus } from '@chiroup/core/enums/SmsConsentStatus.enum';

interface CarrierOptedOutWarningProps {
  transactionalConsentStatus?: SmsConsentStatus | string;
  marketingConsentStatus?: SmsConsentStatus | string;
  className?: string;
}

/**
 * Warning component shown when patient has opted out via STOP message
 * This indicates a carrier-level opt-out that requires the patient to send START
 */
export const CarrierOptedOutWarning: React.FC<CarrierOptedOutWarningProps> = ({
  transactionalConsentStatus,
  marketingConsentStatus,
  className = '',
}) => {
  const isCarrierOptedOut =
    transactionalConsentStatus === SmsConsentStatus.CARRIER_OPTED_OUT ||
    marketingConsentStatus === SmsConsentStatus.CARRIER_OPTED_OUT;

  if (!isCarrierOptedOut) {
    return null;
  }

  return (
    <div className={`p-3 bg-red-50 border border-red-200 rounded-md ${className}`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <svg
            className="h-5 w-5 text-red-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">Patient Opted Out via STOP</h3>
          <div className="mt-1 text-xs text-red-700">
            This patient has opted out by replying STOP. They must text START to the clinic number
            to resume receiving messages. Consent cannot be recorded through this interface until
            they opt back in.
          </div>
        </div>
      </div>
    </div>
  );
};
